<div class="card mat-elevation-z8" *ngIf="errorMessage">
    <div class="card-header">
        Alert
    </div>
    <div class="card-body">
        <div class="row">
            <div>
                <div class="row">
                    <div class="alert alert-danger">
                        {{errorMessage}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card mat-elevation-z8">
    <mat-drawer-container>
        <mat-drawer #drawer position="end" mode="over" disableClose="true">
            <app-edit-details [selectedRows]="selection.selected" [isAddButtonClicked]="isAddButtonClicked"
                [carriers]="carriers.data" (closeEditDetails)="drawer.toggle()"
                (refreshCarrierTable)="refreshCarrierTable()" (resetAddButton)="resetAddButton()"></app-edit-details>
        </mat-drawer>
        <mat-drawer-content>
            <div class="card-header">
                <div class="row">
                    <div class="col-md-1 align-self-end">
                        {{selection.selected.length}} Selected
                    </div>

                    <mat-form-field subscriptSizing="dynamic" class="col-md-3 align-self-end">
                        <mat-label>Filter</mat-label>
                        <input matInput [(ngModel)]="filter" #ctrl="ngModel" (keyup)="applyFilter($event)" #input>
                    </mat-form-field>

                    <div class="col-md-1 align-self-end">
                        <button *ngIf="isLoadingPayers"  mat-flat-button color="primary">
                            Loading...
                        </button>
                    </div>

                    <div class="button-group col-md-3 offset-md-4 align-self-end">
                        <button mat-raised-button color="primary" [disabled]="isAddButtonDisabled()"
                            (click)="[drawer.toggle(), addButtonClicked()]">
                            Add
                        </button>

                        <button mat-raised-button color="primary" [disabled]="isEditButtonDisabled()"
                            (click)="drawer.toggle()">
                            Edit
                        </button>

                        <button mat-raised-button color="warn" [disabled]="isDeleteButtonDisabled()"
                            (click)="openDialog()">
                            Delete
                        </button>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="table-container">
                    <table mat-table [dataSource]="carriers" matSort>

                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? toggleAllRows() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? onSelectRow($event, row) : null"
                                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="carrierName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Epic/Legacy Payer</th>
                            <td mat-cell *matCellDef="let row"> {{row.carrierName}} </td>
                        </ng-container>

                        <ng-container matColumnDef="payerState">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Payer State</th>
                            <td mat-cell *matCellDef="let row"> {{ !row.payerState && row.payerName ? "National" :
                                row.payerState }} </td>
                        </ng-container>

                        <ng-container matColumnDef="payerName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Experian Payer</th>
                            <td mat-cell *matCellDef="let row"> {{row.payerName}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                        </tr>
                    </table>
                </div>

                <mat-paginator [length]="totalCount" [pageSizeOptions]="[10, 25, 50, 100]"
                    aria-label="Select page of payers" showFirstLastButtons></mat-paginator>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>